import validate from 'validate.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const validateRulesForm = ({
  requires_production_insurance,
  insurance_requirement_description = '',
  can_move_furniture,
  furniture_move_description = ''
}) => {
  const validations = {};

  if (requires_production_insurance && '' !== insurance_requirement_description) {
    Object.assign(validations, {
      insurance_requirement_description: validate.single(insurance_requirement_description,
        {
          length: {
            minimum: 3,
            tooShort: (<FormattedMessage id="hosting.validate_rules_form.insurance_min_character_message" defaultMessage="Enter at least 3 characters"/>)
          }
        })
    });
  }

  if (can_move_furniture && '' !== furniture_move_description) {
    Object.assign(validations, {
      furniture_move_description: validate.single(furniture_move_description,
        {
          length: {
            minimum: 3,
            tooShort: (<FormattedMessage id="hosting.validate_rules_form.max_character_message" defaultMessage="Enter at least 3 characters"/>)
          }
        })
    });
  }

  return validations;
};

export default validateRulesForm;
